module.exports = {"UM_DOMAIN":"testplpum.heymath.com","REV_DOMAIN":"testplprevision.heymath.com","PC_DOMAIN":"testplppc.heymath.com","WEB_DOMAIN":"testplp.heymath.com","OPS_DOMAIN":"testops.heymath.com","LUMOS_PC_DOMAIN":"testpc.heymath.com","LUMOS_UM_DOMAIN":"testlumos.heymath.com","WIRIS_DOMAIN":"testme.heymath.com","CS_DOMAIN":"testcs.heymath.com","CP_DOMAIN":"testcontest.heymath.com","CONTEST_UM_DOMAIN":"testplpum.heymath.com","CP_DOMAIN_API":"testcontest.heymath.com/api","ANALYTICS_DOMAIN":"testanalytics.heymath.com"}


//////////////////
// WEBPACK FOOTER
// ./src/config/urls.json
// module id = 655
// module chunks = 0